import React, { FC, PropsWithChildren } from 'react';

import styles from './index.module.sass';

interface ILinkProps {
  dataTurbolinks?: string;
  href: string;
  target?: string;
}

export const Link: FC<PropsWithChildren<ILinkProps>> = ({
  children,
  dataTurbolinks,
  href,
  target,
}) => (
  <li className={styles.item}>
    <a
      className={styles.link}
      data-turbolinks={dataTurbolinks}
      href={href}
      rel={target === '_blank' ? 'noreferrer' : undefined}
      target={target}
    >
      {children}
    </a>
  </li>
);
